import { Link, useNavigate } from "react-router"
import { useAuth } from "../contexts/authContext"
import { LogIn, Search, Crown } from "lucide-react"
import { useSearchParams } from 'react-router';

function NavBar({ className = "" }) {
  const { user, logout } = useAuth()
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate()
  
  const handleSearchSubmit = (e) => {
    e.preventDefault()
    const searchTerm = e.target[0].value

    if (window.location.path == '/discover'){
      setSearchParams({ search: searchTerm })
      return;
    }
    return navigate(`/discover?search=${searchTerm}`)
  }

  return (
    <div className={`${className}`}>
      <div className="navbar w-full bg-base-100 shadow-sm">
        <div className="container mx-auto px-4 py-2 flex items-center justify-between">
          <div className="">
            <Link to={"/"} className="btn btn-ghost text-2xl font-bold">
              ExamsPrep
            </Link>
          </div>
          <form
            onSubmit={handleSearchSubmit}
            className="hidden md:flex items-center bg-gray-100 rounded-full px-4 flex-1 max-w-md mx-4"
          >
            <Search size={18} className="text-gray-500 mr-2" />
            <input
              type="text"
              placeholder="Search topics, courses..."
              className="input bg-transparent border-none outline-none w-full focus-within:border-none focus-within:outline-none text-sm "
            />
          </form>
          <div className="flex items-center gap-4">
            {!user && (
              <>
                <Link to={"/signup"} className="btn btn-outline btn-primary rounded-3xl hidden sm:flex">
                  Signup
                </Link>
                <Link to={"/login"} className="btn btn-primary rounded-3xl">
                  {" "}
                  <LogIn size={16} /> Login
                </Link>
              </>
            )}
            {user?.is_admin && (
              <Link to={"/admin"} className="btn btn-primary btn-outline rounded-3xl">
                Admin
              </Link>
            )}
            {!user?.is_admin && user?.user_type == "lecturer" && (
              <Link to={"/lecturer/quizzes"} className="btn btn-primary btn-outline rounded-3xl">
                Dashboard
              </Link>
            )}
            {user && (
              <div className="dropdown dropdown-end">
                <div tabIndex={0} role="button" className="btn btn-ghost btn-circle avatar">
                  <div className="w-10 rounded-full">
                    <img
                      alt="Tailwind CSS Navbar component"
                      src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp"
                    />
                  </div>
                </div>
                <ul
                  tabIndex={0}
                  className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
                >
                  {/* Subscription status in dropdown */}
                  <li className="mb-1">
                    {user.has_active_subscription ? (
                      <div className="flex items-center justify-between">
                        <span>Subscription</span>
                        <span className="px-2 py-0.5 bg-yellow-500 text-white text-xs font-medium rounded-full">
                          Premium
                        </span>
                      </div>
                    ) : (
                      <Link
                        to="/subscription"
                        className="flex items-center justify-between text-violet-600 font-medium"
                      >
                        <span>Subscription</span>
                        <span className="flex items-center gap-1">
                          <Crown size={14} />
                          <span>Upgrade</span>
                        </span>
                      </Link>
                    )}
                  </li>
                  <li>
                    <Link to={"/profile"} className="justify-between">
                      Profile
                      <span className="badge">New</span>
                    </Link>
                  </li>
                  <li>
                    <a onClick={logout}>Logout</a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavBar